import api from '../index';

export default {
  get(q = '', month = null, status = '') {
    let url = '/blog/stories';
    const filters = [];

    q.trim() !== '' && filters.push(`q=${q}`);
    month && filters.push(`month=${month}`);
    status.trim() !== '' && filters.push(`status=${status}`);

    url = `${url}?${filters.join('&')}`;

    return api.get(url);
  },
  getById(id) {
    return api.get(`/blog/stories/${id}`);
  },
  create(payload) {
    return api.post(`/blog/stories`, { blog_stories: payload });
  },
  update(payload) {
    return api.put(`/blog/stories`, { blog_stories: [payload] });
  },
  updateMultiple(payload) {
    return api.put(`/blog/stories`, { blog_stories: payload });
  },
  updatePriority(payload) {
    return api.put(`/blog/stories/priority`, { blog_stories: [payload] });
  },
};
